module.exports = __webpack_public_path__ + "src/assets/img/1.86e1fcc3.jpg";